const useAddOwnerOptions = (owners, schema) => {
  const options = owners?.map(({ firstName, lastName, id }) => ({
    value: Number(id),
    label: `${firstName} ${lastName}`
  }));

  return schema.map(field => ({
    ...field,
    ...(field.name === "ownerId" ? { options } : {})
  }));
};

export default useAddOwnerOptions;
